import * as React from "react";
import "./LearnerCourses.css";
import Header from "../../Header";
import BreadCrumb from "@/components/BreadCrumb";
import ProgressBar from "@/components/ProgressBar/ProgressBar";

declare const I18n;

type Course = {
  id: number;
  title: string;
  requiredLevel: number;
  index: number;
  image?: string | null;
  isFacilitator?: boolean;
  isLearner?: boolean;
  completed?: boolean;
  learnerLevel?: number;
};

type Props = {
  learner: {
    id: number;
    first_name: string;
  };
  courses: Course[];
};

const completedIcon = <svg width="23" height="18" viewBox="0 0 23 18" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M22.293 3.59375L8.625 17.2617L0.707031 9.34375L3.59375 6.45703L8.625 11.4883L19.4062 0.707031L22.293 3.59375Z" fill="#42C0C6" stroke="#4C1862" />
</svg>


const LearnerCourses: React.FunctionComponent<Props> = ({
  learner,
  courses,
}) => {
  const courseCount = courses.length;
  let levelText = "";

  return (
    <div className="learner-courses-container">
      <Header title="Learner's Courses" />
      <BreadCrumb
        locations={[
          {
            title: I18n.t("models.learner.attributes.learners"),
            url: "/learners",
          },
          { title: I18n.t("models.learner.learner_courses.title"), url: "" },
        ]}
      />

      <h2 className="title">
        {I18n.t('models.learner.learner_courses.progress_overview', { name: learner.full_name })}
      </h2>

      {courseCount === 0 ? ( // If no courses, show a message
        <div className="no-courses-message">
          {I18n.t('models.learner.learner_courses.no_courses_message', { name: learner.full_name })}
        </div>
      ) : (
        <div
          className={`learner-courses-grid ${courseCount === 2 ? "two-courses" : ""
            }`
          }
        >
          {courses.map((course, index) => {
            const [hovered, setHovered] = React.useState(false);
            if (course.requiredLevel === 0) {
              levelText = I18n.t("models.course.required_level.0");
            } else if (course.requiredLevel === -1) {
              levelText = I18n.t("models.course.required_level.-1");
            } else {
              levelText = "Hackergal Course";
            }

            const isAdmin = !(course.isLearner || course.isFacilitator);
            const imageUrl = course.image || null;

            const imageNode = (
              <div className="card-list-item__image-container">
                {imageUrl ? (
                  <div
                    className="card-list-item__image card-list-item__image--background"
                    style={{ backgroundImage: `url(${imageUrl})` }}
                  />
                ) : (
                  <div className="card-list-item__image card-list-item__image--default"></div>
                )}

                {hovered && (
                  <div className="facilitator-overlay">
                    <button
                      className="facilitator-btn"
                      onClick={() =>

                        (window.location.href = `/courses/${course.id}/lessons`)
                      }
                    >
                      {I18n.t('models.learner.learner_courses.view_course')}
                    </button>
                    <button
                      className="facilitator-btn"
                      onClick={(event) => {
                        event.preventDefault();
                        event.stopPropagation();
                        window.location.href = `/courses/${course.id}/learners/${learner.id}`;
                      }}
                    >
                      {I18n.t('models.learner.learner_courses.view_learner_progress')}
                    </button>
                  </div>
                )}
              </div>
            );

            const completed = course.submittedLessons === course.totalLessons

            return (
              <div
                className="card-list-item"
                style={{ backgroundColor: 'white' }}
                onMouseEnter={() => setHovered(true)}
                onMouseLeave={() => setHovered(false)}
                key={course.id}
              >
                {imageNode}
                <div className="card-list-item__card-type-container">
                  <i className="fal fa-book-open fa-1x card-list-item__icon" />
                  <div className="card-list-item__level">{levelText}</div>
                </div>
                <div className="card-list-item__meta-container">
                  <div className="card-list-item__title-container card-list-item-title-container" style={{ paddingBottom: "0px" }}>
                    <div
                      id={`courses_title_${course.id}`}
                      className="card-list-item__title"
                      style={{ color: '#333' }}
                    >
                      {course.title}
                    </div>
                  </div>
                </div>
                {completed && (
                  <div style={{
                    border: "1px solid #42C0C6",
                    borderRadius: "0.625rem",
                    padding: ".525em 1em",
                    gap: "1.75rem",
                    color: "#333",
                    width: "fit-content",
                  }}><svg width="23" height="18" viewBox="0 0 23 18" fill="none" xmlns="http://www.w3.org/2000/svg" style={{marginRight:"0.4rem"}}>
                      {completedIcon}
                    </svg>{I18n.t("models.course.messaging.completed")}
                  </div>)
                }
                {!completed && (<ProgressBar value={course.submittedLessons} total={course.totalLessons} card />
                )}
              </div>
            );
          })}
        </div>
      )
      }
    </div >
  );
};

export default LearnerCourses;
